import { Component, OnInit, ViewChild } from '@angular/core';
import { Utils } from '../utils/utils';

@Component({
  selector: 'app-creacionusuarios',
  templateUrl: './creacionusuarios.component.html',
  styleUrls: ['./creacionusuarios.component.css']
})
export class CreacionusuariosComponent implements OnInit {
  dataPersonaActualiza = 0;
  constructor(public ruta: Utils) {}

  ngOnInit() {
    //alert(this.router.url);
    this.ruta.setRuta();
  }

  actualizaPadrePersona(valor) {
    //alert(valor);
    this.dataPersonaActualiza += valor;
  }
}
